module.exports = __webpack_public_path__ + "img/nosotros-clientes.28984d41.png";